import { COLORS_CONFIG } from 'config';

const AVAILABLE_COLORS = Object.values(COLORS_CONFIG);

export default AVAILABLE_COLORS;
